const OUTLET_REASON_LABELS = {
  exitBrand: 'Вивід бренду',
  exitProduct: 'Вивід окремих позицій',
  productExpiration: 'Експірація товару',
}

const getOutletReasonLabel = (value) => OUTLET_REASON_LABELS[value] || value || '-'

export default getOutletReasonLabel
